<template>

  <transition enter-active-class='animated animated3 fadeIn' leave-active-class='animated animated3 fadeOut'>
    <div v-if="visible" class='layerlogin'>
        <div class='login clearfix'>

          <div class='left nprogress'>
            <h3>登陆你的账号</h3>
            <div class='a description'>
              任何时间，任何地点，你都可以开始你的创作
            </div>
            <div class='b'>
              <div class="input-group">
                <input type="text" class="form-control" v-model='phone' placeholder="手机号">
                <span class="input-group-btn">
                  <button style='width:95px;' v-if='number==0' class="btn btn-default huanchong" @click='getSms' :disabled=!smsBool type="button">获取验证码</button>
                  <button style='width:95px;' v-else class="btn btn-default" :disabled=!smsBool type="button">{{number}}秒</button>
                </span>
              </div>
            </div>
            <div class='c'>
              <div class="input-group">
                <span class="input-group-addon">验证码</span>
                <input type="text" class="form-control" v-model='code'>
              </div>
            </div>
            <div class='d'>
              <div class='row'>
                <div class='col-xs-6'>
                  <span :class='{active:!loginBool,denglu:true,huanchong:true}' @click='denglu'>立即登录</span>
                </div>
                <div class='col-xs-6'>
                  <span class='denglus huanchong' @click='remove'>取消</span>
                </div>
              </div>
            </div>
            <div class='e description'>
              使用表示你同意时光露台的 <a href="">使用条款</a> 和 <a href="">隐私政策</a>。
            </div>
          </div>

          <div class='right hidden-xs'></div>
        </div>
    </div>
  </transition>

</template>

<script>
  //状态管理变量名
  import * as types from '@/store/types.js';
  //引入通用common
  import commons from '@/util/commons.js';
  //结果处理
  import resultCommons from '@/util/resultcommons.js';
  // 顶部加载条组件
  import {NProgress} from '@/util/nprogress.js'; 
  import {apiLoginSms,apiUserLogin} from '@/request/api.js';
  // 状态管理
  import store from '@/store/store.js';
  export default {
    name:'Layerlogin',
    data(){
      return {
        visible:false,
        //电话号码
        phone:'',
        //验证码
        code:'',
        //是否可以点击
        sms:true,
        //倒计时
        number:0,
        //登陆状态
        loginState:true
      }
    },
    computed:{
      smsBool(){
        if(commons.isPoneAvailable(this.phone) && this.sms){
          return true;
        }else{
          return false;
        }
      },
      //登录按钮状态
      loginBool(){
        if(this.loginState && this.phone && this.code){
          return true;
        }else{
          return false;
        }
      }
    },
    methods:{
      remove(){
        this.visible = false;
      },
      //获取短信验证码
      getSms(){
        //如果合规
        if(this.smsBool){
          console.log('获取验证码');
          //开启进度条
          NProgress.configure({parent: '.nprogress'});
          NProgress.start();
          //不可点获取验证码按钮
          this.sms = false;
          //执行请求
          apiLoginSms({phone:this.phone,type:1}).then(ob=>{
            resultCommons.apiLoginSms(ob,this);
          }).catch(ob=>{
            resultCommons.apiLoginSms({state:1004,message:'请求失败',data:[]},this);
          });
        }
      },
      //登录操作
      denglu(){
        //可以执行登录
        if(this.loginBool){
          console.log('登录操作');
          //开启进度条
          NProgress.configure({parent: '.nprogress'});
          NProgress.start();
          //不可点获取验证码按钮
          this.loginState = false;
          //执行请求
          apiUserLogin({phone:this.phone,code:this.code}).then(ob=>{
            resultCommons.apiUserLogin(ob,this,store,1);
          }).catch(ob=>{
            resultCommons.apiUserLogin({state:1004,message:'请求失败',data:[]},this,store,1);
          });
        }
      }
    },
    watch: {
      //监听是否出现滚动
        visible (val) {
            if (val) {
              document.body.style.overflow = 'hidden'
              document.addEventListener('touchmove', ()=>{
              }, {passive: false}) // 禁止页面滑动
          } else {
              document.body.style.overflow = '' // 出现滚动条
              document.removeEventListener('touchmove', ()=>{
              }, {passive: false})
          }
        },
        number (val) {
          // 开始计时时
          if(val==60){
            var that = this;
            //执行定时任务
            that.timer = setInterval(()=>{
              if(that.number<=0){
                that.sms = true;
                //关闭定时任务
                clearInterval(that.timer);
              }else{
                //递减
                that.number--;
              }
            }, 1000);
          }
        }
    }

  }

</script>


<style scoped lang='less'>
    


  .layerlogin{
    height:100%;
    position:absolute;
    top:0px;
    right:0px;
    bottom:0px;
    left:0px;
    z-index:2;
    background-color:rgba(0,0,0,0.6);
  }
  .login{
      width:640px;
      height:384px;
      margin:auto;
      background:#FFF;
      border-radius:3px;
      margin-top:5%;
      overflow: hidden;
      margin-bottom:40px;

    .left{
      float: left;
      padding:30px;
      width: 437px;
      input{
        padding-top:18px;
        padding-bottom:18px;
        box-shadow: none;
        &:focus{
          border-color: #F89413;
        }
      }
      h3{
        margin-top:20px;
        font-size:25px;
        font-weight: bold;
      }
      div.a{
        font-size: 12px;
        margin-top: 15px;
        margin-bottom: 30px;
      }
      div.b{
        margin-bottom:20px;
        button{
          padding-top:8px;
          padding-bottom:8px;
        }
      }
      div.c{
        .input-group-addon{
          background-color: #FFF;
          color:#333333;
        }
      }
      div.d{
        margin-top: 20px;
      }
      div.e{
        margin-top:40px;
        font-size: 12px;
      }
      .denglu{
          display: inline-block;
          background: #ED5243;
          font-size:14px;
          font-weight:bold;
          color:#FFF;
          padding: 10px 20px;
          border-radius: 5px;
          width: 100%;
          text-align: center;
          cursor: pointer;
          &:hover{
            background:#DB4334;
          }
          &.active{
            background:#FF7E71;
            cursor:not-allowed;
          }
      }
      .denglus{
          display: inline-block;
          background: #909399;
          font-size:14px;
          font-weight:bold;
          color:#FFF;
          padding: 10px 20px;
          border-radius: 5px;
          width: 100%;
          text-align: center;
          cursor: pointer;
          &:hover{
            background:#797E86;
          }
      }
    }

    .right{
      float: right;
      background:url(~images/logon.png) center center;
      width: 203px;
      height: 100%;
      background-size: cover;
    }

  }

  @media (max-width: 767px) {
    .login{
      width: 90%;
      margin:auto;
      margin-top:5%;
      height:auto;

      .left{
        width:100%;
        float: none;
      }
      .right{
        width:100%;
        float: none;
      }
    }
  }

  .animated1 {
      animation-duration: 0.1s;
      animation-fill-mode: both;
  }
  .animated2 {
      animation-duration: 0.2s;
      animation-fill-mode: both;
  }
  .animated3 {
      animation-duration: 0.3s;
      animation-fill-mode: both;
  }


</style>



// WEBPACK FOOTER //
// src/components/common/login/index.vue